// extracted by mini-css-extract-plugin
module.exports = {"container":"paypal-payment-button_container__SYl7x","frame":"paypal-payment-button_frame__wZD_p"};